import { Drawer } from '@material-ui/core';
import * as React from 'react';
import * as Forms from '../../../../components/form-elements/_index';
import { FlyoutSaveCancel } from '../../../../components/flyout-components/FlyoutSaveCancel';
import { FlyoutTitle } from '../../../../components/flyout-components/FlyoutTitle';
import { InventorySvc } from '../../../../shared/services/inventory-service';

import { PhysicalInventoryCreateItem } from '../../../../modules/inventory/models/physical-inventory-create-item';
import { DateInput } from '../../../../components/form-elements/_index';


interface IProps {
    visible         : boolean;
    onSuccess       : any;
    onClose         : any;
}

export const ActionCreateInventoryReport = (props: IProps) => {

    const [service] = React.useState(new InventorySvc());
    const [reportInfo, setReportInfo] = React.useState<PhysicalInventoryCreateItem>(new PhysicalInventoryCreateItem());
    const [controlMapFile, setControlMapFile] = React.useState<any>();
    
    React.useEffect(() => {
        if (props.visible) {    

            setReportInfo(new PhysicalInventoryCreateItem());
        }
    }, [props.visible]);

    const onSaveInfo = async () => {

        if (reportInfo.name && reportInfo.date && controlMapFile) {

            service.createPhysicalReport(reportInfo.name, reportInfo.date, controlMapFile).then((result) => {
                props.onSuccess();
            });            
        }
    };

    /**
     * Cleanup some our state and close the panel
     */
    const onClose = () => {
        props.onClose();
    };

    /**
     * Handler for changing the date.
     * @param newDate The new date as chosen 
     */
    const onDateChange = (newDate: Date) => {

        const reportInfoClone: PhysicalInventoryCreateItem = { ...reportInfo };
        reportInfoClone.date = newDate;
        setReportInfo(reportInfoClone);
    };

    /**
     * Handler for changing the name.
     * @param newName The new name as chosen 
     */
    const onNameChange = (e: any) => {

        const reportInfoClone: PhysicalInventoryCreateItem = { ...reportInfo };
        reportInfoClone.name = e.target.value;
        setReportInfo(reportInfoClone);
    };

    const setFile = (evt: any) => {
        setControlMapFile(evt.target.files[0]);
    };


    return reportInfo
        ? <Drawer
            anchor="right"
            data-testid="stop-action-basic-info"
            onClose={onClose}
            open={props.visible}>
            <div className="stop-action-drawer mini stop-action-basic-info">

                <FlyoutTitle
                    onMobileClose={onClose}
                    title="Create Inventory Report" />

                <div className="row">
                    <div className="col-md-12">
                        <Forms.TextInput
                            id="reportName"
                            type="text"
                            label="Name"
                            value={reportInfo.name}
                            onChange={onNameChange}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <DateInput
                            id="reportDate"
                            label="Date"
                            value={reportInfo.date}
                            onChange={onDateChange}
                            inline={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="label">
                                CONTROL MAP FILE
                            </label>
                            <input
                                id="controlMapFile"
                                accept=".xls, .xlsx"
                                type="file"
                                name="file"
                                onChange={setFile} />
                        </div>
                    </div>
                </div>
                <FlyoutSaveCancel
                    onSave={onSaveInfo}
                    onCancel={onClose}
                />
            </div>
        </Drawer>
        : null;
};
